namespace GeniuzPOS.Common.Helpers {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class PostFgStatusFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
            if (chanel == 0) {
                return "<i class='fa fa-file text-danger'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFB6C1; color: #CD5C5C; border: none;'>UnPost</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-check-square text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>POSTED</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-clock text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFE4B5; color: #DAA520; border: none;'>รอสั่งประมวลผลสิ้นวัน</button>";
            } else if (chanel == 3) {
                return "<i class='fa fa-sync-alt fa-spin text-info'></i> " +
                       "<button class='btn btn-sm' style='background-color: #87CEEB; color: #4682B4; border: none;'>กำลังประมวลผล</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }
@Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
export class AdjCodeStatusFormatter implements Slick.Formatter {

    format(ctx: Slick.FormatterContext) {
        var text = Q.htmlEncode(ctx.value);

        if (!this.chanalPropertyId) {
            return text;
        }

        let chanel = ctx.item[this.chanalPropertyId];
        
        if (chanel == 1) {
            return "<i class='fa fa-minus-circle text-danger'></i> " +
                   "<button class='btn btn-sm' style='background-color: #FFB6C1; color: #CD5C5C; border: none;'>ปรับปรุงลด</button>";
        } else if (chanel == 2) {
            return "<i class='fa fa-plus-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>ปรับปรุงเพิ่ม</button>";
        } else {
            return chanel;
        }
    }

    @Serenity.Decorators.option()
    public chanalPropertyId: string;

    public initializeColumn(column: Slick.Column) {
        column.referencedFields = column.referencedFields || [];
        if (this.chanalPropertyId)
            column.referencedFields.push(this.chanalPropertyId);
    }
}

    
@Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
export class UseFgsFormatter implements Slick.Formatter {

    format(ctx: Slick.FormatterContext) {
        var text = Q.htmlEncode(ctx.value);

        if (!this.chanalPropertyId) {
            return text;
        }

        let chanel = ctx.item[this.chanalPropertyId];
        
        if (chanel == 1) {
            return "<i class='fa fa-check-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>ใช้งาน</button>";
        } else if (chanel == 0) {
            return "<i class='fa fa-times-circle text-danger'></i> " +
                   "<button class='btn btn-sm' style='background-color: #FFB6C1; color: #CD5C5C; border: none;'> </button>";
        } else {
            return chanel;
        }
    }

    @Serenity.Decorators.option()
    public chanalPropertyId: string;

    public initializeColumn(column: Slick.Column) {
        column.referencedFields = column.referencedFields || [];
        if (this.chanalPropertyId)
            column.referencedFields.push(this.chanalPropertyId);
    }
}

@Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
export class AdjFgFormatter implements Slick.Formatter {

    format(ctx: Slick.FormatterContext) {
        var text = Q.htmlEncode(ctx.value);

        if (!this.chanalPropertyId) {
            return text;
        }

        let chanel = ctx.item[this.chanalPropertyId];
        
        if (chanel == 0) {
            return "<i class='fa fa-check-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>Qty by Avg.</button>";
        } else if (chanel == 1) {
            return "<i class='fa fa-check-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>Qty only</button>";
        } else if (chanel == 2) {
            return "<i class='fa fa-check-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>Cost only</button>";
        } else if (chanel == 3) {
            return "<i class='fa fa-check-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>Qty & Cost</button>";
        } else {
            return chanel;
        }
    }

    @Serenity.Decorators.option()
    public chanalPropertyId: string;

    public initializeColumn(column: Slick.Column) {
        column.referencedFields = column.referencedFields || [];
        if (this.chanalPropertyId)
            column.referencedFields.push(this.chanalPropertyId);
    }
}
@Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
export class CancelFgFormatter implements Slick.Formatter {

    format(ctx: Slick.FormatterContext) {
        var text = Q.htmlEncode(ctx.value);

        if (!this.chanalPropertyId) {
            return text;
        }

        let chanel = ctx.item[this.chanalPropertyId];
        
        if (chanel == 0) {
            return "<i class='fa fa-check-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'></button>";
        } else if (chanel == 1) {
            return "<i class='fa fa-check-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>Cancled</button>";
        } else if (chanel == 2) {
            return "<i class='fa fa-check-circle text-success'></i> " +
                   "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>Inprocess</button>";
        } else {
            return chanel;
        }
    }

    @Serenity.Decorators.option()
    public chanalPropertyId: string;

    public initializeColumn(column: Slick.Column) {
        column.referencedFields = column.referencedFields || [];
        if (this.chanalPropertyId)
            column.referencedFields.push(this.chanalPropertyId);
    }
}


}